module.exports = __webpack_public_path__ + "img/extraction-contingency-plan.f7edb445.jpg";